import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getPaymentManagementModuleName } from './payment-management.permissions';

export class PaymentRequestsPermissions {
  static GroupName = `${getPaymentManagementModuleName()}.PaymentRequests`;

  static getPermissions = getGroupPermissionFactory(PaymentRequestsPermissions.GroupName);

  static Permissions = {
    Read: PaymentRequestsPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: PaymentRequestsPermissions.getPermissions(PermissionEnum.READ_ALL),
  };
}